import { Button, IconButtonProps, makeStyles } from '@material-ui/core';
import { useObserver } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import { useAuth } from '../../stores/AuthStore';
import AuthMenu from './AuthMenu';

const useStyles = makeStyles(theme => ({
  buttonMargin: {
    margin: theme.spacing(1) / 2
  }
}));

type Props = IconButtonProps & {
  onClick: () => void;
  isButtonSignInText?: boolean;
};

const AuthSection: FC<Props> = (props: Props) => {
  const classes = useStyles();
  const authStore = useAuth();

  const { onClick } = props;
  const handleLogout = () => {
    authStore.logout();
  };

  return useObserver(() => (
    <Fragment>
      {authStore.user?.profile?.firstName ? (
        <AuthMenu
          name={authStore.user?.profile.firstName}
          logout={handleLogout}
        />
      ) : (
        <Button
          className={classes.buttonMargin}
          onClick={onClick}
          {...(props.isButtonSignInText
            ? {
                variant: 'text',
                color: 'inherit'
              }
            : {
                variant: 'contained',
                color: 'primary'
              })}
          size="large"
        >
          MEMBER SIGN IN/SIGN UP
        </Button>
      )}
    </Fragment>
  ));
};

export default AuthSection;
